module.exports = __webpack_public_path__ + "static/media/Messages.c48f3de0.png";